import { useMutation } from "@tanstack/react-query";

import { enrichRealEstate } from "@features/real-estate/api/client";
import { buildEnrichmentRequest } from "@features/real-estate/state/constants";
import { useRealEstateWorkspace } from "@features/real-estate/state/workspace";

export function useRealEstateEnrichmentMutation() {
  const { state, dispatch } = useRealEstateWorkspace();

  return useMutation({
    mutationFn: async () => enrichRealEstate(buildEnrichmentRequest(state.intake)),
    onMutate: () => {
      dispatch({ type: "set_enrichment_state", enrichmentState: "loading", error: null });
      dispatch({ type: "set_redirect_notice", notice: null });
    },
    onSuccess: (response) => {
      dispatch({ type: "set_enrichment_state", enrichmentState: "ready", response, error: null });
    },
    onError: (error) => {
      dispatch({
        type: "set_enrichment_state",
        enrichmentState: "error",
        error: error instanceof Error ? error.message : "Failed to enrich property context",
      });
    },
  });
}
